import { Route } from '@angular/router';
import { TenderAwardsComponent } from '../../../../pages/tender-awards/tender-awards.component';

export const tenderAwardsRoute: Route = {
    path: 'awards',
    component: TenderAwardsComponent
};
